export const addThousandSeparotors = (value: string) => {
  if (value === null || value === undefined) return "";

  // Convert numbers to string
  const str = value.toString();

  // Keep only digits
  const numeric = str.replace(/[^\d]/g, "");

  if (numeric === "") return "";

  return Number(numeric).toLocaleString();
};

export const removeThousandSeparotors = (value: string) => {
  return Number(value.toString().replaceAll(",", ""));
};

export const isNumber = (str: string) => {
  return /^-?(\d+\.?\d*|\.\d+)$/.test(str.trim());
};

export const isFormValid = (
  requiredFields: string[],
  dataObj: Record<string, any>
) => {
  const newErrors: Record<string, string> = {};

  requiredFields.forEach((field) => {
    const value = dataObj[field];

    if (Array.isArray(value)) {
      if (value.length === 0) {
        newErrors[field] = `${field} is required`;
      }
    } else if (typeof value === "string") {
      if (!value.trim()) {
        newErrors[field] = `${field} is required`;
      }
    } else if (value === null || value === undefined) {
      newErrors[field] = `${field} is required`;
    } else if (typeof value === "boolean") {
      if (value === false) {
        newErrors[field] = `${field} must be checked`;
      }
    }
    // numbers and other truthy values pass automatically
  });

  return {
    isValid: Object.keys(newErrors).length === 0,
    errors: newErrors,
  };
};
